import { render, staticRenderFns } from "./LsTosText.vue?vue&type=template&id=1e454f6d&scoped=true&"
import script from "./LsTosText.vue?vue&type=script&lang=js&"
export * from "./LsTosText.vue?vue&type=script&lang=js&"
import style0 from "./LsTosText.vue?vue&type=style&index=0&id=1e454f6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e454f6d",
  null
  
)

export default component.exports